(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-scripts"] && !Shopify.designMode) return;
  try {
    // Mobile dots pagination (only run on mobile)
  if (!window.matchMedia('(min-width: 768px)').matches) {
    const container = document.querySelector('.container');
    const images = container ? container.querySelectorAll('.snap-start') : [];
    const pagination = container ? container.querySelector('.pagination') : null;

    if (container && pagination && images.length) {
      let dots = [];
      images.forEach((image, idx) => {
        const dot = document.createElement('button');
        dot.classList.add('dot');
        if (idx === 0) dot.classList.add('active');
        pagination.appendChild(dot);
        dots.push(dot);

        dot.addEventListener('click', () => {
          image.scrollIntoView({ behavior: 'smooth', inline: 'start' });
        });
      });

      const observerOptions = {
        root: container,
        threshold: 0.7
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const idx = Array.from(images).indexOf(entry.target);
            dots.forEach((dot, i) => {
              dot.classList.toggle('active', i === idx);
            });
          }
        });
      }, observerOptions);

      images.forEach(image => observer.observe(image));
    }
  }

  // Desktop accordion logic
  document.querySelectorAll('.accordion-item').forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      const isOpen = content.style.maxHeight;
      document.querySelectorAll('.accordion-content').forEach((c) => {
        c.style.maxHeight = null;
      });
      content.style.maxHeight = isOpen ? null : content.scrollHeight + 'px';
    });
  });

  // Desktop thumbnails -> scroll + active border
  const desktopThumbs = document.querySelectorAll('.desktop-thumb');
  const desktopImages = document.querySelectorAll('[data-desktop-image]');

  if (desktopThumbs.length && desktopImages.length) {
    desktopThumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = btn.getAttribute('data-thumb-index');
        const target = document.querySelector(`[data-desktop-image][data-image-index="${idx}"]`);
        if (!target) return;

        const rect = target.getBoundingClientRect();
        const targetCenterY = rect.top + window.scrollY + rect.height / 2;
        const viewportCenterY = window.innerHeight / 2;

        const y = Math.max(0, targetCenterY - viewportCenterY);

        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    const ratioByIndex = new Map();

    const setActiveThumb = (activeIndex) => {
      desktopThumbs.forEach((btn) => {
        btn.classList.toggle('is-active', btn.getAttribute('data-thumb-index') === String(activeIndex));
      });
    };

    const desktopObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const idx = entry.target.getAttribute('data-image-index');
        if (!idx) return;
        ratioByIndex.set(idx, entry.isIntersecting ? entry.intersectionRatio : 0);
      });

      let bestIdx = null;
      let bestRatio = 0;
      ratioByIndex.forEach((ratio, idx) => {
        if (ratio > bestRatio) {
          bestRatio = ratio;
          bestIdx = idx;
        }
      });

      if (bestIdx) setActiveThumb(bestIdx);
    }, {
      root: null,
      threshold: [0, 0.25, 0.5, 0.75, 1]
    });

    desktopImages.forEach((el) => desktopObserver.observe(el));
    setActiveThumb(1);
  }
  } catch(e) { console.error(e); }
})();

})();
